import { mapGetters, mapActions } from 'vuex'
import { orderBy } from 'lodash'

export default {
  data () {
    return {
      selectedProvider: {},
      selectedProviderToVinculate: null,
      fieldsToSave: [],
      fieldsToDelete: [],
      allFieldsConcat: [],
      dialog: false,
      isLoading: false,
      isLoadingSystemProviders: false,
      isLoadingAuthorizedProviders: false,
      isLoadingVinculateProvider: false,
      customCredentials: false,
      headers: [
        {
          text: 'Authorized Provider',
          value: 'idAuthorizedProvider',
          align: 'left',
          sortable: false
        },
        {
          text: 'Cliente',
          value: 'idClient',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tipo',
          value: 'type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Provider',
          value: 'name',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  watch: {
    selectedProvider (val) {
      if (!val) {
        this.selectedProvider = {}
      }
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterAuthorizedProviders',
      'getterAuthorizedProvidersReadOnly',
      'getterSelectedClient',
      'getterClients',
      'getterSystemProviders'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    },
    optionsVinculateProvider () {
      return {
        loading: this.isLoadingVinculateProvider
      }
    },
    filterSystemProvidersNoAssossiate () {
      const list = this.getterSystemProviders.filter((item) => {
        const recoveryItem = this.getterAuthorizedProvidersReadOnly.find((childItem) => childItem.idSystemProvider === item.idSystemProvider)
        if (recoveryItem || !item.enabled) {
          item.disabled = true
        }

        return item
      })

      return orderBy(list, ['disabled'], ['desc'])
    },
    filteredParamsFields () {
      return this.selectedProviderToVinculate ? this.selectedProviderToVinculate.paramsFields.map((item) => ({ IdParamsFields: item.idParamsField, value: '' })) : []
    },
    selectedProviderFields () {
      const fields = this.selectedProvider && this.selectedProvider.paramsFieldsValue ? this.selectedProvider.paramsFieldsValue : []

      fields.forEach((item) => {
        item.value = item.value || item.defaultValue
      })

      return fields
    }
  },
  mounted () {
    this.dialog = true

    this.getAuthorizedProvidersByClient()

    this.getAllSystemProviders()
  },
  methods: {
    ...mapActions([
      'actionAddAuthorizedProvider',
      'actionUpdateValueByAuthorizedProvider',
      'actionGetAuthorizedProvidersByClient',
      'actionGetAllSystemProviders'
    ]),
    getAllSystemProviders () {
      this.isLoadingSystemProviders = true

      this.actionGetAllSystemProviders()
        .then(() => {
          this.isLoadingSystemProviders = false
        })
        .catch(() => {
          this.isLoadingSystemProviders = false
        })
    },
    checkHasData (value) {
      if (value) {
        const hasValue = value.paramsFieldsValue ? value.paramsFieldsValue.filter((item) => item.value !== '' && item.value !== null) : []

        if (hasValue && hasValue.length > 0) {
          this.customCredentials = true
        } else {
          this.customCredentials = false
        }
      }
    },
    configParams () {
      const params = this.selectedProviderFields.map((item) => ({ idParamsFieldValue: item.idParamsFieldValue, value: item.value }))

      if (params && params.length > 0) {
        this.isLoading = true

        this.actionUpdateValueByAuthorizedProvider(params)
          .then(() => {
            this.sendToast({
              text: 'Parâmetros atualizado com sucesso',
              type: 'success'
            })

            this.closeModal()
          })
          .catch(() => {
            this.sendToast({
              text: 'Ocorreu um erro ao atualizar os parâmetros, tente novamente mais tarde!',
              type: 'danger'
            })

            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'Os valores dos campos não foram encontrados!',
          type: 'warning'
        })
      }
    },
    saveProviders () {
      const params = {
        ...this.selectedProviderToVinculate,
        idClient: this.getterAccount.idClient,
        paramsFieldsValueDTO: this.filteredParamsFields
      }

      this.isLoadingVinculateProvider = true

      this.actionAddAuthorizedProvider(params)
        .then(() => {
          this.isLoadingVinculateProvider = true

          this.getAuthorizedProvidersByClient()
        })
        .catch(() => {
          this.sendToast({
            text: 'Não foi possível vincular o provider',
            type: 'danger'
          })

          this.isLoadingVinculateProvider = false
        })
    },
    getAuthorizedProvidersByClient () {
      this.isLoadingAuthorizedProviders = true

      this.actionGetAuthorizedProvidersByClient(this.getterAccount.idClient)
        .then(() => {
          if (this.isLoadingVinculateProvider) {
            this.sendToast({
              text: 'Provider vinculado com sucesso!',
              type: 'success'
            })

            this.isLoadingVinculateProvider = false
          }

          this.selectedProviderToVinculate = null
          this.isLoadingAuthorizedProviders = false
        })
        .catch(() => {
          this.isLoadingVinculateProvider = this.isLoadingAuthorizedProviders = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os authorized providers, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
